module.exports = __webpack_public_path__ + "static/media/search.c24d4216.svg";